import { FC } from 'react';

import { StyledPopupMain } from './index.styles';
import { StyledPopupMainProps } from '../Modal.types';

const PopupMain: FC<StyledPopupMainProps> = ({ children, className, refElement, flexLayout }) => {
  return (
    <StyledPopupMain className={className} ref={refElement ? refElement : undefined} flexLayout={flexLayout}>
      {children}
    </StyledPopupMain>
  );
};

export default PopupMain;
